import React from "react";

const STATUS_COLORS = {
  DRAFT: { bg: "bg-slate-500/15", text: "text-slate-300", border: "border-slate-500/30", dot: "bg-slate-400" },
  ACTIVE: { bg: "bg-emerald-500/15", text: "text-emerald-300", border: "border-emerald-500/30", dot: "bg-emerald-400" },
  ARCHIVED: { bg: "bg-neutral-500/15", text: "text-neutral-300", border: "border-neutral-500/30", dot: "bg-neutral-400" },
};

const ENV_COLORS = {
  PRODUCTION: { bg: "bg-emerald-500/10", text: "text-emerald-300", border: "border-emerald-500/30" },
  DEVELOPMENT: { bg: "bg-sky-500/10", text: "text-sky-300", border: "border-sky-500/30" },
};

export function CfgStatusBadge({ status, size = "md" }) {
  const c = STATUS_COLORS[status] || STATUS_COLORS.DRAFT;
  const cls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border font-black uppercase tracking-wider ${cls} ${c.bg} ${c.text} ${c.border}`}
      data-testid={`cfg-status-${status.toLowerCase()}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />{status}
    </span>
  );
}

export function CfgEnvBadge({ environment, size = "md" }) {
  const c = ENV_COLORS[environment] || { bg: "bg-white/5", text: "text-white/70", border: "border-white/10" };
  const cls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <span className={`inline-flex items-center rounded-full border font-bold ${cls} ${c.bg} ${c.text} ${c.border}`}
      data-testid={`cfg-env-${environment?.toLowerCase()}`}>
      {environment}
    </span>
  );
}

export function ToggleDot({ on }) {
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-wider ${on ? "text-emerald-300" : "text-neutral-500"}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${on ? "bg-emerald-400" : "bg-neutral-500"}`} />
      {on ? "ON" : "OFF"}
    </span>
  );
}
